import { gql } from '@apollo/client';

export const FETCH_COIN_VALUE_USD = gql`
  query CoinValueUsd {
    coinValueUsd
  }
`;
